var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            _vm._l(_vm.teachers, function (teacher) {
              return _c(
                "v-col",
                {
                  key: teacher.src,
                  attrs: { cols: "12", md: "6", lg: "4", xl: "3" },
                },
                [
                  _c("v-card", {
                    staticClass: "soli-round",
                    staticStyle: { border: "none" },
                    attrs: { ripple: false, disabled: teacher.disabled },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }